function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M47.6562 6.44551C55.1621 11.8068 60.0469 20.5756 60.0469 30.5C60.0469 46.7984 46.8461 60.0111 30.5596 60.0469C14.2969 60.0826 0.976933 46.8223 0.953105 30.5477C0.941191 20.6232 5.82596 11.8307 13.3199 6.45742C14.7138 5.46855 16.6558 5.88555 17.4898 7.3748L19.3722 10.7227C20.0752 11.9736 19.7416 13.5582 18.5859 14.416C13.6416 18.0855 10.4844 23.8996 10.4844 30.4881C10.4724 41.4848 19.3603 50.5156 30.5 50.5156C41.4133 50.5156 50.5871 41.6754 50.5156 30.3689C50.4799 24.1975 47.5728 18.2404 42.4021 14.4041C41.2465 13.5463 40.9248 11.9617 41.6277 10.7227L43.5101 7.3748C44.3441 5.89746 46.2742 5.45664 47.6562 6.44551ZM35.2656 31.4531V2.85938C35.2656 1.2748 33.9908 0 32.4062 0H28.5937C27.0092 0 25.7344 1.2748 25.7344 2.85938V31.4531C25.7344 33.0377 27.0092 34.3125 28.5937 34.3125H32.4062C33.9908 34.3125 35.2656 33.0377 35.2656 31.4531Z",
  fill: "#EEAD07"
});

function SvgPower(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.de8d9be2.svg";
export { ForwardRef as ReactComponent };